var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgGoodThings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 363.99 436.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#6abeec;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M294.5,94.46C277.18,88.05,267.55,72.62,263.57,53,259.21,31.5,276.13,9.36,295.85,4.81s40.08,4.91,55.34,19c2.52,2.34,5,4.89,6.42,8.18,1.62,3.75,1.69,8.12,1.24,12.27-1.85,17.25-11.76,32.29-22.8,44.84C328.3,98,316.43,106.51,307,100.32A123.91,123.91,0,0,0,294.5,94.46Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M311.68,181.62C291.38,132.73,244.14,88.47,192,69.44S84.54,57.34,52,87c-6.93,6.31-13,13.78-15.1,23.25-2.29,10.26.22,22,2,33.3,8,52.18-1.09,102.36-25.69,142-4.12,6.63-8.73,13.18-9.84,21.34C1,324.45,14.92,344,28.26,360.9c21.94,27.77,48.54,57.88,81.67,65.85,26.59,6.4,50.28-3.79,66.77-18.69s27.74-34.36,43-50.4C267.76,307,351.92,278.58,311.68,181.62Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgGoodThings);
export default __webpack_public_path__ + "static/media/bg_good_things.67d62e27b2c78a485c5a36bb49c0c4fe.svg";
export { ForwardRef as ReactComponent };